export { NotFoundErrorMessage, StandardErrorMessage } from './lib/domain/error-message';
export { ErrorService } from './lib/util-error/error.service';
import { fallbackRoutes } from './lib/fallback.routes';

export default fallbackRoutes;
